// extracted by mini-css-extract-plugin
module.exports = {"cardHeading":"OrderSummarySegment-CardHeading-module--card-heading--2Ctc9 utils-module--uppercase--2OdP1"};